import { Divider } from '@mui/material';
import classes from './PricingTab.module.scss';
import i18n from '../../../../../utils/i18n';
import Calculator from './components/Calculator';
import TextfieldUnit from '../../../../components/TextfieldUnit';

import ExtraFeeInputs from './components/inputs/extraFeeInputs';

import AccountingPricing from './components/inputs/accountingPricing';
import PayrollPricing from './components/inputs/payrollPricing';
import TaxconPricing from './components/inputs/taxconPricing';
import FoundingPricing from './components/inputs/foundingPricing';
import AuditPricing from './components/inputs/auditPricing';

import {
	invoicesExtra,
	foreignTradeExtra,
	revenueExtra,
	vatExtra,
	providerCompanyIndustryList,
	providerCompanyTypeList,
	payrollPricing,
} from '../../../../data/providerText';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import ACTIONS from '../../../../../redux/action';

// import { useSelector, useDispatch } from 'react-redux';

const Pricing = ({ providerData, setSaveMessage, setSeverity }) => {
	const dispatch = useDispatch();

	const [
		industryFilter,
		serviceFilter,
		accountingPrice,
		companyTypeFilter,
		specialRestr,
		payrollPrice,
	] = useSelector((state) => [
		state.provider_industry_restrictions,
		state.provider_services,
		state.provider_acc_monthly_price,
		state.provider_business_filter,
		state.provider_special_restrictions,
		state.provider_payroll_price,
	]);

	const inputChangeHandler = (e, item, filterObj, arrObj) => {
		//console.log(e, item, 'ASDASD');
		let tempObj = filterObj.filter((i) => i.id === item.id)[0];
		tempObj.value = parseInt(e.target.value);
		dispatch(
			ACTIONS.updateArrayofObjProviderInfo({
				updatedObj: tempObj,
				arrOfObj: arrObj,
			})
		);
	};

	const getObject = (id, array) => {
		return array.filter((e) => e.id === id)[0];
	};
	const checkAccounting = () => {
		let filled = true;

		providerCompanyTypeList().forEach((item) => {
			if (
				companyTypeFilter[item.id] &&
				(accountingPrice[`${item.id}price`] === undefined ||
					accountingPrice[`${item.id}price`] === null ||
					accountingPrice[`${item.id}price`] === '')
			) {
				//	console.log(item, 'INSIDE IF');

				filled = false;
			} else {
			}
		});

		return filled;
	};
	const checkPayroll = () => {
		let filled = true;
		payrollPricing().forEach((item) => {
			// console.log(serviceFilter, 'serviceFilter');
			if (
				payrollPrice[item.id] === undefined ||
				payrollPrice[item.id] === null ||
				payrollPrice[item.id] === ''
			) {
				// //	console.log(item, 'item');

				filled = false;
			} else {
			}
		});

		return filled;
	};
	const checkInvoices = () => {
		let filled = true;
		invoicesExtra().forEach((item) => {
			if (
				accountingPrice[item.id] === undefined ||
				accountingPrice[item.id] === null ||
				accountingPrice[item.id] === ''
			) {
				// console.log(item, 'item');

				filled = false;
			} else {
			}
		});

		return filled;
	};
	const checkForeignTrade = () => {
		let filled = true;
		foreignTradeExtra().forEach((item) => {
			if (
				(specialRestr.insideEU || specialRestr.outsideEU) &&
				(accountingPrice.foreigntradeextra === undefined ||
					accountingPrice.foreigntradeextra === null ||
					accountingPrice.foreigntradeextra === '')
			) {
				// console.log(item, 'item');
				filled = false;
			} else {
			}
		});
		return filled;
	};
	const checkRevenue = () => {
		let filled = true;
		revenueExtra().forEach((item) => {
			if (
				accountingPrice[item.id] === undefined ||
				accountingPrice[item.id] === null ||
				accountingPrice[item.id] === ''
			) {
				// console.log(item, 'item');
				filled = false;
			} else {
			}
		});
		return filled;
	};
	const checkVat = () => {
		let filled = true;
		vatExtra().forEach((item) => {
			if (
				accountingPrice[item.id] === undefined ||
				accountingPrice[item.id] === null ||
				accountingPrice[item.id] === ''
			) {
				filled = false;
			} else {
			}
		});
		return filled;
	};

	const checkFills = () => {
		if (
			checkAccounting() &&
			checkForeignTrade() &&
			checkRevenue() &&
			checkVat() &&
			checkInvoices() &&
			checkPayroll()
		) {
			setSaveMessage(i18n.t('general.savesuccess'));
			setSeverity('success');
			//console.log('TRUE');
			return true;
		} else {
			setSaveMessage(i18n.t('provider.fillallfields'));
			setSeverity('warning');
			//console.log('FALSE');
			return false;
		}
	};

	useEffect(() => {
		checkFills();
	}, [accountingPrice, payrollPrice]);

	return (
		<div className={classes.containerMain}>
			<div className={classes.containerLeft}>
				<div className={classes.profileTitle}>
					{i18n.t('provider.calculator')}
				</div>
				<div className={classes.profileSubTitle}>
					{i18n.t('provider.calculatorsub')}
				</div>
				<Calculator providerData={providerData} />
			</div>
			<div className={classes.containerRight}>
				{/* <div className={classes.leftColumn}>
						<div className={classes.profileSubTitle}>
							{i18n.t('provider.mainparameterssub')}
						</div>
						<div>
							<TagSimple label={i18n.t('provider.maintag1')} />
							<TagSimple label={i18n.t('provider.maintag2')} />
							<TagSimple label={i18n.t('provider.maintag3')} />
						</div>
						<CustomButton
							buttonName={i18n.t('provider.fillwithai')}
							iconSrc={IconWizardGrey}
							buttonColor='#fafcfe'
							hoverColor='#fafcfe'
							titleColor='#4b5080'
							titleHoverColor='#4b5080'
							width='220px'
							height='44px'
							padding='12px'
							borderColor='#e3e5e9'
							borderWidth='1px'
							onClick={() => setOpenDialogAI(true)}
						/>
						<DialogAI
							openDialogAI={openDialogAI}
							setOpenDialogAI={setOpenDialogAI}
						/>
					</div> */}
				<div className={classes.profileTitle}>
					{i18n.t('provider.accountingbaseprices')}
				</div>
				<div className={classes.profileSubTitle}>
					{i18n.t('provider.accountingbasepricessub')}
				</div>
				<AccountingPricing />

				<Divider sx={{ margin: '18px 0' }} />

				{serviceFilter.payroll && (
					<>
						<div className={classes.profileTitle}>
							{i18n.t('general.payroll')}
						</div>
						{/* <div className={classes.profileSubTitle}>
							{i18n.t('provider.payrollsub')}
						</div> */}
						<PayrollPricing />

						<Divider sx={{ margin: '18px 0' }} />
					</>
				)}

				{(serviceFilter.taxconsulting ||
					serviceFilter.taxconsultingcomplex) && (
					<>
						<div className={classes.profileTitle}>
							{i18n.t('general.taxconsulting')}
						</div>
						<TaxconPricing />

						<Divider sx={{ margin: '18px 0' }} />
					</>
				)}

				{serviceFilter.legalentityfounding && (
					<>
						<div className={classes.profileTitle}>
							{i18n.t('general.legalentityfounding')}
						</div>
						<div className={classes.textfieldWrapper}>
							<FoundingPricing />
						</div>
						<Divider sx={{ margin: '18px 0' }} />
					</>
				)}

				{serviceFilter.audit && (
					<>
						<div className={classes.profileTitle}>
							{i18n.t('general.audit')}
						</div>
						<div className={classes.textfieldWrapper}>
							<AuditPricing />
						</div>
						<Divider sx={{ margin: '18px 0' }} />
					</>
				)}

				<div className={classes.profileTitle}>
					{i18n.t('provider.numberofinvoices')}
				</div>
				<div className={classes.profileSubTitle}>
					{i18n.t('provider.numberofinvoicessub')}
				</div>
				<div className={classes.textfieldWrapper}>
					<ExtraFeeInputs
						dataText={invoicesExtra()}
						title={i18n.t('provider.invoiceextrafees')}
						unit={`${i18n.t('general.currency')} / ${i18n.t('general.piece')}`}
					/>
				</div>

				<Divider sx={{ margin: '18px 0' }} />

				<div className={classes.profileTitle}>
					{i18n.t('provider.foreigntradeextra')}
				</div>
				<div className={classes.profileSubTitle}>
					{i18n.t('provider.foreigntradeextrasub')}
				</div>
				<div className={classes.textfieldWrapper}>
					<ExtraFeeInputs
						dataText={foreignTradeExtra()}
						unit={i18n.t('general.percentage')}
					/>
				</div>

				<Divider sx={{ margin: '18px 0' }} />

				<div className={classes.profileTitle}>
					{i18n.t('provider.totalrevenue')}
				</div>
				<div className={classes.profileSubTitle}>
					{i18n.t('provider.totalrevenuesub')}
				</div>
				<ExtraFeeInputs
					dataText={revenueExtra()}
					//title={i18n.t('provider.invoiceextrafees')}
					unit={i18n.t('general.percentage')}
				/>

				<Divider sx={{ margin: '18px 0' }} />
				<div className={classes.profileTitle}>
					{i18n.t('provider.frequencyofvatreturn')}
				</div>
				<div className={classes.profileSubTitle}>
					{i18n.t('provider.frequencyofvatreturnsub')}
				</div>
				<ExtraFeeInputs
					dataText={vatExtra()}
					unit={i18n.t('general.percentage')}
				/>

				<Divider sx={{ margin: '18px 0' }} />

				<div className={classes.profileTitle}>
					{i18n.t('provider.industriesextra')}
				</div>
				<div className={classes.profileSubTitle}>
					{i18n.t('provider.industriesextrasub')}
				</div>
				<div className={classes.paragraphTwoColumns}>
					{providerCompanyIndustryList().map((item, idx) => {
						let fetchedData = getObject(item.id, industryFilter);
						return (
							fetchedData && (
								<TextfieldUnit
									idx={idx}
									title={item.label}
									isRequired={false}
									showAsterix={false}
									unit={i18n.t('general.percentage')}
									value={fetchedData?.value ?? 0}
									onChange={(event) =>
										inputChangeHandler(
											event,
											item,
											industryFilter,
											'provider_industry_restrictions'
										)
									}
								/>
							)
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default Pricing;
